<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
      v-if="session != null"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/nuevo-pedido">
        <md-icon>new_releases</md-icon>
        <p>Nuevo Pedido</p>
      </sidebar-link>
      <sidebar-link to="/pedidos">
        <md-icon>content_paste</md-icon>
        <p>Pedido</p>
      </sidebar-link>
      <sidebar-link to="/caja">
        <md-icon>attach_money</md-icon>
        <p>Caja</p>
      </sidebar-link>
      <sidebar-link to="/gestionar-fecha">
        <md-icon>date_range</md-icon>
        <p>Gestionar Fecha</p>
      </sidebar-link>
      <sidebar-link to="/consultar-fecha">
        <md-icon>today</md-icon>
        <p>Consultar Fecha</p>
      </sidebar-link>
    </side-bar>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
      v-else
    >
      <sidebar-link to="/login">
        <md-icon>meeting_room</md-icon>
        <p>Login</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content v-if="session != null"> </dashboard-content>
      <login v-else></login>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import Login from "@/pages/Login.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    Login
  },
  data() {
    return {
      session: null,
      sidebarBackground: "orange",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg")
    };
  },
  mounted() {
    if (localStorage.usertoken == null) {
      this.$router.push("/login");
    } else {
      this.session = 1;
    }
  }
};
</script>
